//Name: Union Members
//CODE: UNIO
//Age: ''
//Gender: Both
const unionMemberOptions = [
  { id: '72', name: 'SAG' },
  { id: '73', name: 'SAG Eligible' },
  { id: '74', name: 'UBCP' },
  { id: '75', name: 'UBCP Apprentice' },
  { id: '76', name: 'AFTRA' },
  { id: '77', name: 'AFTRA Permitee' },
  { id: '78', name: 'UDA' },
  { id: '79', name: 'UDA Stagiaire' },
  { id: '80', name: 'UDA Permitee' },
  { id: '81', name: 'ACTRA' },
  { id: '82', name: 'ACTRA Apprentice' },
  { id: '83', name: 'EQUITY' },
  { id: '84', name: 'EQUITY Permitee' },
  { id: '85', name: 'AEA' },
  { id: '86', name: 'CAEA' },
  { id: '87', name: 'BAEA' },
  { id: '88', name: 'MEAA' },
  { id: '135', name: ':: None ::' },
  { id: '151', name: 'AFCU' }
]; 

export default unionMemberOptions;



// WEBPACK FOOTER //
// ./src/data/union-member-options.js